import React from 'react';
import { Hidden } from '@material-ui/core';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { Tiers } from '../models/coverage-models';
import { getEmployeeAndSpouseLabel } from '../helpers/coverage-display-helpers';

interface Props {
	settings: NewHireProps;
	tiers: Tiers;
}

export function DeskTopTierLabel(props: Props) {

	const { settings, tiers } = props;



	return (
		<Hidden xsDown>
			{tiers?.I && <div className='coverage-table-row-cell tier-cell'> <h5>{settings?.singleTierLabel}</h5></div>}
			{tiers?.T && <div className='coverage-table-row-cell tier-cell'> <h5>{getEmployeeAndSpouseLabel(tiers, settings)}</h5></div>}
			{tiers?.G && <div className='coverage-table-row-cell tier-cell'> <h5>{settings?.empPlusChildTierLabel}</h5></div>}
			{tiers?.D && <div className='coverage-table-row-cell tier-cell'> <h5>{settings?.empPlusMultiTierLabel}</h5></div>}
			{tiers?.F && <div className='coverage-table-row-cell tier-cell'> <h5>{settings?.familyTierLabel}</h5></div>}
			
			
		</Hidden>
	);
}


